import { useState } from 'react';
import FloatingInput from '../components/FloatingInput';
import Spacer from '../components/Spacer';
import APIUrls from '../core/ApiUrls';
import Toastify from '../core/Toastify';
import { MakeAxiosRequest } from '../core/utils';
import LoginStateManager from '../core/LoginStateManager';
import { Navigate, useNavigate } from 'react-router-dom';

const Signup = () => {
    const [email, setEmail] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleSignup = async () => {
        const notAllDetails = !email.trim() || !firstName.trim() || !lastName.trim() || !password.trim();
        if (notAllDetails) {
            Toastify.error('Please Fill All The Details');
            return;
        }
        const reqBody = {
            email,
            firstName,
            lastName,
            password,
        };
        setLoading(true);
        try {
            const res = await MakeAxiosRequest('POST', APIUrls.getURL('SIGNUP'), reqBody);
            console.log(res);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (LoginStateManager.isLoggedIn()) {
        return <Navigate to={'/dashboard'} />;
    }

    return (
        <div className="bg-[#f8f8f8] flex flex-col justify-center items-center h-screen w-screen">
            <h1 className="text-4xl font-bold text-center text-gray-800 mb-3">
                Clento <span className="text-purple-500">Reporter</span>
            </h1>
            <span className="text-purple-600 text-sm w-1/4 text-center mb-3">Track all important for you accounts, so you don’t miss anything important.</span>
            <div className="bg-white rounded-2xl shadow-xl p-10 border border-gray-100 w-full max-w-md flex flex-col items-center">
                <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">SignUp</h1>
                <Spacer spacing={30} />
                <div className="grid grid-cols-2 gap-2">
                    <FloatingInput label="First Name" type="text" value={firstName} onChange={setFirstName} />
                    <FloatingInput label="Last Name" type="text" value={lastName} onChange={setLastName} />
                </div>
                <Spacer spacing={30} />
                <FloatingInput label="Email" type="email" value={email} onChange={setEmail} />
                <Spacer spacing={30} />
                <FloatingInput label="Password" type="password" value={password} onChange={setPassword} isPassword />
                <Spacer spacing={40} />
                <button disabled={loading} className="w-full bg-gradient-purple hover:hover-gradient-purple transition text-white py-3 rounded-xl font-semibold shadow-sm disabled:hover-gradient-purple disabled:cursor-wait" onClick={() => handleSignup()}>
                    Sign up
                </button>
                <div className="flex flex-row w-full text-center justify-center items-center mt-6">
                    <span className="text-sm">Already have an account?&nbsp;</span>
                    <span className="text-sm text-purple-500 cursor-pointer" onClick={() => navigate('/login')}>
                        Login
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Signup;
